import BaseModel from './BaseModel';

class ParticipationAndQuestionnaireFilterOption extends BaseModel {}

ParticipationAndQuestionnaireFilterOption.collection =
  'projections.ParticipationAndQuestionnaireFilterOptions';

export default ParticipationAndQuestionnaireFilterOption;
